module.exports = __webpack_public_path__ + "teqbahn-assets/media/16.1f09eb51.png";